const { ALGOLIA_APPLICATION_ID, ALGOLIA_ENV, ALGOLIA_SEARCH_API, APP_ENV } = process.env
const applicationId: string = ALGOLIA_APPLICATION_ID || ''
const searchApi: string = ALGOLIA_SEARCH_API || ''
const algoliaEnv: string = ALGOLIA_ENV || APP_ENV || 'production'
const searchIndice: string = `${algoliaEnv}_all_artworks`
export const config: Record<string, any> = {
  applicationId,
  searchApi,
  searchIndice,
}